export default "__VITE_ASSET__DNZir1SV__"